import React, { useState, Fragment, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";
import { withRouter } from "react-router";
import { Modal } from "react-bootstrap";

import './Login.scss';
import LoginForm from './Components/LoginForm/LoginForm';
import RecoveryPassword from './Components/RecoveryPassword/RecoveryPassword';
import NewPassword from './Components/NewPassword/NewPassword';
import DropdownMenu from '../../../components/DropdownMenu/DropdownMenu';

import { ThemingContext } from '../../../hoc/Theming/Theming';

import LogoIco from '../../../statics/hol-logo-mt.png';
import Illustration from '../../../statics/illustration-login.png';

const Login = (props) => {
  const { t, i18n } = useTranslation();
  const styling = useContext(ThemingContext);
  const [dropdownLang, setDropdownLang] = useState('English');

  const preferences =
      useSelector((state) => state.preferences.preferences) || {};

  let imageLogin = preferences && preferences.image_login
  let headerOne = t('login.header_one')
  let headerTwo = t('login.header_two')
  let loginRightSideLogo = null
  if(window._app_config.REACT_APP_LOGIN_SETTING){
    const setting = window._app_config.REACT_APP_LOGIN_SETTING.split('|')
    if(setting[0] && setting[0] !== '' ){ imageLogin = setting[0] === 'none' ? setting[0] : ( require('statics/'+setting[0]).default || require('statics/'+setting[0]) ) }
    if(setting[3] && setting[3] !== '' ){ headerOne = setting[3] }
    if(setting[4] && setting[4] !== '' ){ headerTwo = setting[4] }
    loginRightSideLogo = setting[6] && ( require('statics/'+setting[6]).default || require('statics/'+setting[6]) )
  }

  let lang = localStorage.getItem('language');

  useEffect(() => {
    lang === 'id' ? setDropdownLang('Indonesia') : setDropdownLang('English')
  }, [lang])

  const enLangHandler = () => {
    i18n.changeLanguage('en');
    localStorage.setItem("language", 'en');
    setDropdownLang('English');
  };

  const idLangHandler = () => {
    i18n.changeLanguage('id');
    localStorage.setItem("language", 'id');
    setDropdownLang('Indonesia');
  };

  const languages = [
    { label: 'English', action: () => enLangHandler() },
    { label: 'Indonesia', action: () => idLangHandler() }
  ];

  return (
      <div className='login'>

        { props.onExpiredInfo && <Modal size="lg" show={true} aria-labelledby="example-modal-sizes-title-lg" >
          <Modal.Header >
            <Modal.Title id="example-modal-sizes-title-lg">
              {t('customerManagement.expiredInfoTitle')}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center mt-4 mb-4">
            <p>{props.onExpiredInfo}</p>
          </Modal.Body>
        </Modal>
        }
        <div className='left-side' style={styling.component.login}>
          {/* <img className='logo' src={LogoIco} alt='Logo' /> */}
          <div className="d-flex justify-content-center">
            { imageLogin === 'none' ? null : <img className='illustration' src={imageLogin || Illustration} alt='Illustration' /> }
          </div>
        </div>
        <div className='right-side' style={{backgroundImage: `url(${loginRightSideLogo})`,  backgroundPosition: 'right top', backgroundRepeat: 'no-repeat' }} >
          <div className="right-side__wrapper" >
            {
              props.match.path === '/recovery-password' ?
                  <Fragment>
                    <p className='header__text mb-5' style={styling.text.bold}>{t('login.forgotPassword')}</p>
                    <RecoveryPassword />
                  </Fragment>
                  : (props.match.path === '/recovery-password/change' ?
                      <Fragment>
                        <p className='header__text mb-5'>{t('login.setNewPassword')}</p>
                        <NewPassword />
                      </Fragment>
                      :
                      <Fragment>
                        <p className='mb-5'>
                          <e className="header__text_light">{headerOne}</e>
                          <br/>
                          <e className="header__text_light" > {headerTwo} </e>
                        </p>
                        <LoginForm />
                      </Fragment>)
            }
            <div className='dropdown__language justify-content-center'>
              <DropdownMenu
                  drop='up'
                  variant='secondary'
                  items={languages}
                  label={dropdownLang}
              />
            </div>
            <div className="mt-5 text-center">
              <span>Powered By </span><a rel="noopener noreferrer" href="https://www.hukumonline.com" target="_blank"><img className='login-logo' src={LogoIco} alt='Logo' /> </a>
            </div>
          </div>
        </div>
      </div>
  );
};

export default withRouter(Login);
